import React from 'react';

import styles from './AsSeenIn.module.scss';

import foxLogo from '../../public/images/logos/fox-logo.svg';
import forbesLogo from '../../public/images/logos/forbes-logo.svg';
import usaTodayLogo from '../../public/images/logos/usa-today-logo.svg';
import techcrunchLogo from '../../public/images/logos/techcrunch-logo.svg';
import businessInsider from '../../public/images/logos/business-insider.svg';

const { 'as-seen-in': asSeenInClass, 'logo-container': logoContainerClass } = styles;

const logoArray = [
  { url: foxLogo, altText: 'Fox' },
  { url: forbesLogo, altText: 'Forbes' },
  { url: usaTodayLogo, altText: 'USA Today' },
  { url: techcrunchLogo, altText: 'Tech Crunch' },
  { url: businessInsider, altText: 'Business Insider' }
];

const AsSeenIn = ({ logos = logoArray }) => {
  return (
    <div className={asSeenInClass}>
      <span>As Seen In</span>
      <div className={logoContainerClass}>
        {logos.map(logo => (
          <img key={logo.url} src={logo.url} alt={logo.altText} />
        ))}
      </div>
    </div>
  );
};

export default AsSeenIn;
